import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import theme from '../theme';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const PendingActionsPage = () => {
  const navigate = useNavigate();
  const [portfolios, setPortfolios] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchPendingPortfolios();
  }, []);

  const fetchPendingPortfolios = async () => {
    setLoading(true);
    try {
      const token = localStorage.getItem('token');
      const res = await axios.get(`${API}/creator/portfolios/pending-actions`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setPortfolios(Array.isArray(res.data.portfolios) ? res.data.portfolios : []);
    } catch (error) {
      console.error('Error fetching pending portfolios:', error);
      setPortfolios([]);
    } finally {
      setLoading(false);
    }
  };

  const handlePortfolioClick = (portfolioId) => {
    navigate(`/creator/portfolios/${portfolioId}`);
  };

  const formatDate = (dateString) => {
    if (!dateString) return 'N/A';
    return new Date(dateString).toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric'
    });
  };

  const getStatusColor = (status) => {
    const colors = {
      'DRAFT': theme.colors.text.muted,
      'draft': theme.colors.text.muted,
      'NEEDS_REVIEW': '#FFC107',
      'PENDING_APPROVAL': theme.colors.primary
    };
    return colors[status] || theme.colors.text.muted;
  };

  return (
    <div style={{ padding: '40px' }}>
      <h1 style={{ fontSize: '32px', fontWeight: 700, color: theme.colors.text.primary, marginBottom: '16px' }}>
        Pending Actions
      </h1>
      <p style={{ fontSize: '16px', color: theme.colors.text.secondary, marginBottom: '32px' }}>
        Portfolios requiring your attention
      </p>
      <div style={{
        background: theme.colors.bg.card,
        border: `1px solid ${theme.colors.borders}`,
        borderRadius: theme.radius.card,
        padding: '24px'
      }}>
        {loading ? (
          <div style={{ textAlign: 'center', padding: '60px 0', color: theme.colors.text.muted }}>
            Loading portfolios...
          </div>
        ) : portfolios.length > 0 ? (
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))', gap: '16px' }}>
            {portfolios.map(p => (
              <div 
                key={p.id} 
                onClick={() => handlePortfolioClick(p.id)}
                data-testid={`pending-portfolio-card-${p.id}`}
                style={{
                  padding: '16px',
                  background: theme.colors.bg.secondary,
                  borderRadius: theme.radius.sm,
                  cursor: 'pointer',
                  border: `1px solid ${theme.colors.borders}`,
                  transition: 'transform 0.2s, box-shadow 0.2s'
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = 'translateY(-2px)';
                  e.currentTarget.style.boxShadow = '0 4px 12px rgba(0,0,0,0.1)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = 'translateY(0)';
                  e.currentTarget.style.boxShadow = 'none';
                }}
              >
                <div style={{
                  width: '100%',
                  height: '120px',
                  background: p.nft_image_url || `linear-gradient(135deg, ${theme.colors.primary}, ${theme.colors.neon.blue})`,
                  borderRadius: theme.radius.sm,
                  marginBottom: '12px'
                }} />
                <div style={{ fontSize: '16px', fontWeight: 600, color: theme.colors.text.primary }}>{p.name}</div>
                <div style={{ 
                  fontSize: '12px', 
                  color: getStatusColor(p.status), 
                  marginTop: '4px',
                  fontWeight: 500
                }}>
                  {p.status}
                </div>
                <div style={{ fontSize: '12px', color: theme.colors.text.muted, marginTop: '4px' }}>
                  Created: {formatDate(p.created_at)}
                </div>
                {p.kickback_percent && (
                  <div style={{ fontSize: '12px', color: theme.colors.primary, marginTop: '4px' }}>
                    {p.kickback_percent}% kickback
                  </div>
                )}
              </div>
            ))}
          </div>
        ) : (
          <div style={{ textAlign: 'center', padding: '60px 0', color: theme.colors.text.muted }}>
            No pending actions — you're all caught up!
          </div>
        )}
      </div>
    </div>
  );
};

export default PendingActionsPage;
